import React from "react";
import "./App.css";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { WaveCanvas, SiteNav, SiteFooter } from "./Home";
const CoachImg = "/images/wajdi-aidan-coach-athlete-of-year-awards.png";

const CottbusImg =
  "/images/aidan-li-and-wajdi-bouallegue-2026-artistic-gymnastics-cottus-world-cup-2.jpg";
const WorldsImg =
  "/images/aidan-li-and-wajdi-bouallegue-2025-artistic-gymnastics-world-championships-3.png";

export default function News() {
  const { t } = useTranslation();

  const articles = [
    {
      to: "/news/wajdi-bouallegue-coaching-2025-2026",
      titleKey: "coach_season_title",
      subKey: "coach_season_sub",
      img: CoachImg,
      alt: "Wajdi Bouallègue coaching Aidan Li during the 2025-2026 season",
    },
    {
      to: "/news/aidan-li-2026-artistic-gymnastics-cottbus-world-cup",
      titleKey: "aiden_cottbus",
      subKey: "cottbus_2026",
      img: CottbusImg,
      alt: "Aidan Li and Wajdi Bouallègue at the 2026 Cottbus World Cup",
    },
    {
      to: "/news/aidan-li-2025-artistic-gymnastics-world-championships",
      titleKey: "aiden_worlds",
      subKey: "worlds_2025",
      img: WorldsImg,
      alt: "Aidan Li and Wajdi Bouallègue at the 2025 World Championships",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Olympic Wave | News</title>
        <meta
          name="description"
          content="Latest gymnastics news, competition recaps, and international results from my athletes."
        />
        <meta property="og:title" content="Olympic Wave | News" />
        <meta
          property="og:description"
          content="Competition recaps, photos, and results from international gymnastics events."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://olympicwave.ca/news" />
      </Helmet>

      <WaveCanvas />
      <div className="ow-page">
        <SiteNav />

        <main className="ow-inner" style={{ maxWidth: "1200px" }}>
          <div className="ow-page-header">
            <p className="ow-eyebrow">Olympic Wave</p>
            <h1 className="ow-page-title">{t("news")}</h1>
          </div>

          <div className="ow-news-grid">
            {articles.map(({ to, titleKey, subKey, img, alt }) => (
              <NavLink key={to} to={to} className="ow-news-card">
                <img src={img} alt={alt} className="ow-news-card-img" />
                <div className="ow-news-card-overlay">
                  <h2 className="ow-news-card-title">{t(titleKey)}</h2>
                  <p className="ow-news-card-sub">{t(subKey)}</p>
                </div>
              </NavLink>
            ))}
          </div>
        </main>

        <SiteFooter />
      </div>
    </>
  );
}
